import { error, type Load } from '@sveltejs/kit';
import { load as loadProduct } from '@glimja/storefront/pages/product';

export const load: Load = async (event) => {
  try {
    const data = await loadProduct(event as unknown as any);
    return data;
  } catch (e) {
    error(404, 'Not found');
  }
};
